import { useEffect, useState, useContext } from "react";
import { Button } from "@mui/material";
import InputText from "../../../shared/components/inputs/InputText/InputText";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "../categoriasFinanceiro/CategoriasFinanceiro.scss";
import { AuthContext } from "../../../shared/context/auth-context";
import { Popconfirm } from "antd";
import ErrorIcon from "@mui/icons-material/Error";
import PageviewIcon from "@mui/icons-material/Pageview";
import toast from "react-hot-toast";
import codigoPaises from "../../clientes/components/codigoPaises";
import Autocomplete from "@mui/material/Autocomplete";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import { TextField } from "@mui/material";
import { useLoading } from "../../../shared/context/LoadingContext";
import { ClinicaContext } from "../../../shared/context/clinica-context";

import { Collapse, IconButton, Paper, Divider } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import SearchIcon from "@mui/icons-material/Search";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { CircularProgress } from "@mui/material";
import NotaPartilhaUnidades from "../components/NotaPartilhaUnidades";

function ClientesFinanceiros({ sendRequest, clinicaId }) {
  const { startLoading, stopLoading } = useLoading();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [nomeClienteFinanceiro, setNomeClienteFinanceiro] = useState("");
  const [nifClienteFinanceiro, setNifClienteFinanceiro] = useState("");
  const [contactoClienteFinanceiro, setContactoClienteFinanceiro] =
    useState("");
  const [enderecoClienteFinanceiro, setEnderecoClienteFinanceiro] =
    useState("");
  const [emailClienteFinanceiro, setEmailClienteFinanceiro] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [idClienteFinanceiro, setIdClienteFinanceiro] = useState(null);
  const [clientesFinanceiros, setClientesFinanceiros] = useState([]);
  const [mensagemDeErro, setMensagemDeErro] = useState("");
  const [pais, setPais] = useState({ nome: "CABO VERDE", codigo: "CV" });
  const auth = useContext(AuthContext);

  const clinica = useContext(ClinicaContext);

  const [expandedSearch, setExpandedSearch] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchingByName, setSearchingByName] = useState(false);

  useEffect(() => {
    const fetchClientesFinanceiros = async () => {
      startLoading();
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/clientesfornecedores/clinica/${clinicaId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        setClientesFinanceiros(responseData.clientesFornecedores);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchClientesFinanceiros();
  }, [auth.token, clinicaId, sendRequest]);

  const nomeClienteFinanceiroChangeHandler = (valor) => {
    setNomeClienteFinanceiro(valor);
  };

  const nifClienteFinanceiroChangeHandler = (valor) => {
    setNifClienteFinanceiro(valor);
  };

  const contactoClienteFinanceiroChangeHandler = (valor) => {
    setContactoClienteFinanceiro(valor);
  };

  const enderecoClienteFinanceiroChangeHandler = (valor) => {
    setEnderecoClienteFinanceiro(valor);
  };

  const emailClienteFinanceiroChangeHandler = (valor) => {
    setEmailClienteFinanceiro(valor);
  };

  // Custom option rendering function
  const renderOption = (props, option) => (
    <Box
      component="span"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "8px",
      }}
      {...props}
    >
      <Typography variant="subtitle1">{option.nome}</Typography>
      <Typography variant="body2" color="textSecondary">
        {option.codigo}
      </Typography>
    </Box>
  );

  const guardarClienteFinanceiro = async () => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("nome", nomeClienteFinanceiro);
      formData.append("contacto", contactoClienteFinanceiro);
      formData.append("nif", nifClienteFinanceiro);
      formData.append("email", emailClienteFinanceiro);
      formData.append("endereco", enderecoClienteFinanceiro);
      formData.append("pais", JSON.stringify(pais));
      formData.append("clinica", clinicaId);
      formData.append("criadoPor", auth.userId);

      const clienteFornecedorCriada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/clientesfornecedores/`,
        "POST",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      setClientesFinanceiros((current) => [
        ...current,
        clienteFornecedorCriada.clienteFornecedor,
      ]);

      resetarValores();

      setOpenModal(false);
      setIdClienteFinanceiro(null);

      toast.success("Cliente-financeiro criado com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
    setIsSubmitting(false);
  };

  const editarClienteFinanceiro = async (id) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("nome", nomeClienteFinanceiro);
      formData.append("contacto", contactoClienteFinanceiro);
      formData.append("nif", nifClienteFinanceiro);
      formData.append("email", emailClienteFinanceiro);
      formData.append("endereco", enderecoClienteFinanceiro);
      formData.append("pais", JSON.stringify(pais));
      formData.append("atualizadoPor", auth.userId);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/clientesfornecedores/${id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      const clienteFinanceirorCopy = [...clientesFinanceiros];
      const clientesFornecedoresModificadas = clienteFinanceirorCopy.map(
        (clf) => {
          if (clf.id === id) {
            return {
              id: id,
              _id: id,
              nome: nomeClienteFinanceiro,
              contacto: contactoClienteFinanceiro,
              nif: nifClienteFinanceiro,
              endereco: enderecoClienteFinanceiro,
              pais: pais,
              email: emailClienteFinanceiro,
            };
          } else {
            return clf;
          }
        }
      );

      setClientesFinanceiros([...clientesFornecedoresModificadas]);

      resetarValores();
      setIdClienteFinanceiro(null);
      setOpenModal(false);

      toast.success("Cliente-financeiro modificado com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
    setIsSubmitting(false);
  };

  const preEditarClienteFinanceiro = async (id) => {
    setIdClienteFinanceiro(id);
    const clienteFinanceiroFiltrado = clientesFinanceiros.filter(
      (cat) => cat.id === id
    )[0];

    setNomeClienteFinanceiro(clienteFinanceiroFiltrado.nome);
    setContactoClienteFinanceiro(clienteFinanceiroFiltrado.contacto);
    setNifClienteFinanceiro(clienteFinanceiroFiltrado.nif);
    setEnderecoClienteFinanceiro(clienteFinanceiroFiltrado.endereco);
    setEmailClienteFinanceiro(clienteFinanceiroFiltrado.email);
    setPais(clienteFinanceiroFiltrado.pais);
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setMensagemDeErro("");
    setIdClienteFinanceiro(null);
    setOpenModal(false);
    resetarValores();
  };

  const resetarValores = () => {
    setNomeClienteFinanceiro("");
    setNifClienteFinanceiro("");
    setContactoClienteFinanceiro("");
    setEmailClienteFinanceiro("");
    setEnderecoClienteFinanceiro("");
    setPais({ nome: "CABO VERDE", codigo: "CV" });
  };

  const desativarClienteFinanceiro = async (id) => {
    startLoading();
    try {
      const formDataDesativar = new FormData();
      formDataDesativar.append("utilizador", auth.userId);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/clientesFornecedores/toggleativo/${id}`,
        "PATCH",
        formDataDesativar,
        {
          Authorization: "Bearer " + auth.token,
        }
      );
      setClientesFinanceiros((current) =>
        current.filter((cat) => cat.id !== id)
      );

      toast.success("Cliente-financeiro desativado com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const validateTelefoneField = (value) => {
    const digitPattern = /^\d{7}$/;
    return digitPattern.test(value.replace(/\s/g, ""));
  };

  const beforeSubmit = (idClienteFinanceiro) => {
    let haErro = false;

    let duplicidadeClienteFornecedor = false;
    if (idClienteFinanceiro) {
      duplicidadeClienteFornecedor = clientesFinanceiros.filter(
        (c) =>
          c._id !== idClienteFinanceiro &&
          c.nome.toLowerCase() === nomeClienteFinanceiro.trim().toLowerCase()
      );
    }

    if (
      !nomeClienteFinanceiro ||
      nomeClienteFinanceiro.trim() === "" ||
      !contactoClienteFinanceiro ||
      contactoClienteFinanceiro.trim() === "" ||
      !nifClienteFinanceiro ||
      nifClienteFinanceiro === "" ||
      !enderecoClienteFinanceiro ||
      enderecoClienteFinanceiro.trim() === "" ||
      !pais
    ) {
      setMensagemDeErro("Preencha todos os campos assinalados com *");
      haErro = true;
    } else if (
      idClienteFinanceiro &&
      duplicidadeClienteFornecedor?.length > 0
    ) {
      setMensagemDeErro("Já existe um Cliente-financeiro com esse nome.");
      haErro = true;
    } else if (!validateTelefoneField) {
      setMensagemDeErro(
        "O contacto deve ser apenas valores numéricos de 7 digitos e sem espaços"
      );
    } else {
      setMensagemDeErro("");
    }

    if (!isSubmitting && !haErro) {
      setIsSubmitting(true);
      if (idClienteFinanceiro) {
        editarClienteFinanceiro(idClienteFinanceiro);
      } else {
        guardarClienteFinanceiro();
      }
    }
  };

  const findClientInfo = async () => {
    startLoading();
    if (pais.nome !== "CABO VERDE") {
      toast.error("Procura por nif só para Cabo Verde");
    } else {
      if (!nifClienteFinanceiro || nifClienteFinanceiro === "") {
        toast.error("Preencha o campo do nif");
      } else {
        const formData = new FormData();
        formData.append("nif", nifClienteFinanceiro);

        try {
          const response = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/documentoeletronico/nifbinome`,
            "PATCH",
            formData,
            {
              Authorization: "Bearer " + auth.token,
            }
          );

          if (!response?.payload) {
            toast.error("Nenhuma resposta da efatura");
          } else if (response.payload.length === 0) {
            toast.error("Nenhum cliente encontrado");
          } else if (response.payload.length === 1) {
            toast.success("Cliente encontrado");
            setNomeClienteFinanceiro(response.payload[0].Name);
            setNifClienteFinanceiro(response.payload[0].TaxId);
          }
        } catch (err) {
          console.error("err", err);
        } finally {
          stopLoading();
        }
      }
    }
  };

  // Função para buscar por nome
  const searchByName = async () => {
    if (!searchTerm || searchTerm.trim() === "") {
      toast.error("Digite um nome para buscar");
      return;
    }

    if (pais.nome !== "CABO VERDE") {
      toast.error("Procura por nome só para Cabo Verde");
      return;
    }

    setSearchingByName(true);
    const formData = new FormData();
    formData.append("nome", searchTerm);

    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/documentoeletronico/nifbinome`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      if (!response?.payload) {
        toast.error("Nenhuma resposta da efatura");
      } else if (response.payload.length === 0) {
        toast.error("Nenhum cliente encontrado");
        setSearchResults([]);
      } else {
        setSearchResults(response.payload);
        setExpandedSearch(true);
      }
    } catch (err) {
      console.error("Erro na busca:", err);
      toast.error("Erro ao buscar cliente");
    } finally {
      setSearchingByName(false);
    }
  };

  const selectClientFromSearch = (cliente) => {
    setNomeClienteFinanceiro(cliente.Name);
    setNifClienteFinanceiro(cliente.TaxId);
    setExpandedSearch(false);
    setSearchResults([]);
    setSearchTerm("");
  };

  return (
    <>
      <div className="categoriasGeral__container">
        {(auth.role === "Médico/Administrador" || auth.role === "Gerente") && (
          <div
            className="categoriasGeral__container__btn-adicionar"
            style={{ width: "240px" }}
          >
            <Button
              variant="contained"
              color="success"
              onClick={(e) => setOpenModal(true)}
            >
              Novo Cliente-Financeiro
            </Button>
          </div>
        )}

        <div
          style={{
            backgroundColor: "#e3f2fd",
            border: "1px solid #90caf9",
            borderRadius: "8px",
            padding: "16px 20px",
            marginBottom: "20px",
            display: "flex",
            gap: "15px",
            alignItems: "flex-start",
            gridColumn: "1/-1",
          }}
        >
          <InfoOutlinedIcon style={{ color: "#1976d2", marginTop: "2px" }} />
          <div
            style={{ fontSize: "14px", color: "#1565c0", lineHeight: "1.6" }}
          >
            <strong
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "15px",
              }}
            >
              O que são Clientes Financeiros?
            </strong>
            <ul style={{ margin: 0, paddingLeft: "18px" }}>
              <li>
                São entidades (ex: INPS, seguradoras) registadas para efeitos de{" "}
                <strong>faturação eletrónica</strong>.
              </li>
              <li>
                Ao registar entradas na área de Financeiro, pode associar um
                cliente financeiro para emissão de documentos fiscais.
              </li>
              <li>
                Os dados de NIF, contacto e endereço são utilizados
                automaticamente nas faturas.
              </li>
              <NotaPartilhaUnidades />
            </ul>
          </div>
        </div>

        {clientesFinanceiros &&
          clientesFinanceiros.map((clienteFinanceiro, index) => (
            <div
              className="categoriasFinanceiro__container__categoria"
              key={index}
            >
              <div className="categoriasFinanceiro__container__categoria--1">
                {clienteFinanceiro.nome}
              </div>
              <div className="categoriasFinanceiro__container__categoria--2">
                {(auth.role === "Médico/Administrador" ||
                  auth.role === "Gerente") &&
                  clienteFinanceiro.nome.toUpperCase() !==
                    "INSTITUTO NACIONAL DE PREVIDENCIA SOCIAL" && (
                    <Popconfirm
                      title={`Desativar Cliente-financeiro`}
                      description={`Confirma desativação do Cliente-financeiro?`}
                      icon={<ErrorIcon style={{ color: "red" }} />}
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={desativarClienteFinanceiro.bind(
                        null,
                        clienteFinanceiro.id
                      )}
                      className="popConfirm--biggerPadding"
                    >
                      <span>Desativar</span>
                    </Popconfirm>
                  )}
                {(auth.role === "Médico/Administrador" ||
                  auth.role === "Gerente") &&
                  clienteFinanceiro.nome.toUpperCase() !==
                    "INSTITUTO NACIONAL DE PREVIDENCIA SOCIAL" && (
                    <span
                      onClick={preEditarClienteFinanceiro.bind(
                        null,
                        clienteFinanceiro.id
                      )}
                    >
                      Editar
                    </span>
                  )}
              </div>
            </div>
          ))}

        <Modal
          open={openModal}
          onClose={handleModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            className="fluxo-atendimento__modal__box adicionar-categoria__modal"
            id="modal__adicionar-categoria"
          >
            <h1 className="fluxo-atendimento__modal__titulo">
              Cliente-financeiro
            </h1>

            <Paper
              elevation={0}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                p: 2,
                mb: 2,
                backgroundColor: "#f5f5f5",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                  Buscar Cliente Existente
                </Typography>
                <IconButton
                  onClick={() => setExpandedSearch(!expandedSearch)}
                  size="small"
                >
                  {expandedSearch ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>

              <Collapse in={expandedSearch}>
                <Divider sx={{ my: 1 }} />

                {/* Campo de busca por nome */}
                <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                  <TextField
                    size="small"
                    fullWidth
                    label="Buscar por nome"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" && searchByName()}
                    disabled={pais.nome !== "CABO VERDE"}
                    helperText={
                      pais.nome !== "CABO VERDE"
                        ? "Disponível apenas para Cabo Verde"
                        : ""
                    }
                  />
                  <IconButton
                    onClick={searchByName}
                    disabled={searchingByName || pais.nome !== "CABO VERDE"}
                    sx={{
                      backgroundColor: "#175c93",
                      color: "white",
                      "&:hover": { backgroundColor: "#124670" },
                    }}
                  >
                    {searchingByName ? (
                      <CircularProgress size={20} />
                    ) : (
                      <SearchIcon />
                    )}
                  </IconButton>
                </Box>

                {/* Resultados da busca */}
                {searchResults.length > 0 && (
                  <Box sx={{ mt: 2, maxHeight: 200, overflowY: "auto" }}>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mb: 1 }}
                    >
                      {searchResults.length} resultado(s) encontrado(s):
                    </Typography>
                    {searchResults.map((cliente, index) => (
                      <Paper
                        key={index}
                        sx={{
                          p: 1.5,
                          mb: 1,
                          cursor: "pointer",
                          "&:hover": { backgroundColor: "#e3f2fd" },
                          border: "1px solid #e0e0e0",
                        }}
                        onClick={() => selectClientFromSearch(cliente)}
                      >
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {cliente.Name}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          NIF: {cliente.TaxId}{" "}
                          {cliente.BI ? `| BI: ${cliente.BI}` : ""}
                        </Typography>
                      </Paper>
                    ))}
                  </Box>
                )}
              </Collapse>
            </Paper>

            <div
              className="adicionar-categoria__modal__container"
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <InputText
                className="adicionar-categoria__modal__container--span2"
                label="Nome do Cliente-financeiro *"
                initialValue={nomeClienteFinanceiro}
                handleChange={nomeClienteFinanceiroChangeHandler}
                id="1"
              />
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "90% 10%",
                  gap: 0,
                }}
              >
                <InputText
                  className="adicionar-categoria__modal__container--span2"
                  label="Nif do Cliente-financeiro *"
                  initialValue={nifClienteFinanceiro}
                  handleChange={nifClienteFinanceiroChangeHandler}
                  id="2"
                />
                <PageviewIcon
                  style={{
                    fontSize: "63px",
                    cursor: "pointer",
                    fill: "#175c93",
                  }}
                  onClick={findClientInfo}
                />
              </div>

              <InputText
                className="adicionar-categoria__modal__container--span2"
                label="Contacto do Cliente-financeiro *"
                initialValue={contactoClienteFinanceiro}
                handleChange={contactoClienteFinanceiroChangeHandler}
                id="3"
              />

              <FormControl
                style={{ width: "100%" }}
                className="adicionar-categoria__modal__container--span2"
              >
                <Autocomplete
                  id="codPais"
                  value={pais}
                  onChange={(e, value) => setPais(value)}
                  options={codigoPaises}
                  getOptionLabel={(option) =>
                    `${option.nome} - ${option.codigo}`
                  }
                  renderOption={renderOption}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Pais"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </FormControl>

              <InputText
                className="adicionar-categoria__modal__container--span2"
                label="Endereco do Cliente-financeiro *"
                initialValue={enderecoClienteFinanceiro}
                handleChange={enderecoClienteFinanceiroChangeHandler}
                id="4"
              />

              <InputText
                className="adicionar-categoria__modal__container--span2"
                label="Email do Cliente-financeiro"
                initialValue={emailClienteFinanceiro}
                handleChange={emailClienteFinanceiroChangeHandler}
                id="5"
              />
            </div>

            {mensagemDeErro && (
              <div className="erroContainer__categoria-caixa">
                {mensagemDeErro}
              </div>
            )}

            <div className="fluxo-atendimento__modal__bottom_btns">
              <span
                className="cancel-btn"
                onClick={handleModalClose}
                style={{ display: "block" }}
              >
                Fechar
              </span>

              <span
                disabled={isSubmitting}
                className="blue-button"
                onClick={
                  idClienteFinanceiro
                    ? beforeSubmit.bind(null, idClienteFinanceiro)
                    : beforeSubmit.bind(null, null)
                }
              >
                {idClienteFinanceiro
                  ? isSubmitting
                    ? "Guardando"
                    : "Guardar"
                  : isSubmitting
                  ? "Guardando"
                  : "Guardar"}
              </span>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default ClientesFinanceiros;
